import { useState } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { toast } from 'react-hot-toast';
import { faPhone, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faEyeSlash, faEye } from '@fortawesome/free-regular-svg-icons'

function Security1({selectedUser}) {
    const [wcode, setWcode] = useState(selectedUser?.withdraw_code);
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [see, setSee] = useState(false);
    const [pass, setPass] = useState(selectedUser?.password);

    const ValidateCode = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ codeupdate: true, email: selectedUser?.email, wcode:wcode  })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }

    const ValidatePass = () =>{
        setLoading1(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ passupdate: true, email: selectedUser?.email, pass:pass  })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
          }else{
            toast.error(data.message);
          }
          setLoading1(false);
        })
        .catch(err => {
          console.error(err);
          setLoading1(false);
        })
    }

    const ValidateDelete = () =>{
        setLoading2(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ deleteAcc: true, email: selectedUser?.email})
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
          }else{
            toast.error(data.message);
          }
          setLoading2(false);
        })
        .catch(err => {
          console.error(err);
          setLoading2(false);
        })
    }
    return (
        <div>
            <p className="fw-bold mb-0">Security</p>
            <p className="mb-0" style={{fontSize:'14px'}}>Log in to user's account to perform account specific actions. The user's details are shown below:</p>
            <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>User Email:</label>
            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                <input 
                    type="text"
                    placeholder={selectedUser.email}
                    className="inputNone"
                    value={selectedUser.email}
                    readOnly
                />
            </div>
            <label className="fw-semibold my-2" style={{fontSize: '14px'}}>User Password:</label>
            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                <input 
                    type="text"
                    placeholder={selectedUser.password}
                    className="inputNone"
                    value={selectedUser.password}
                    readOnly
                />
            </div>
            <p className="fw-bold mb-0 mt-5">Withdrawal code</p>
            <p className="mb-2" style={{fontSize:'14px'}}>Manage user's withdrawal code.</p>
            <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>Code:</label>
            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                <input 
                    type="text"
                    placeholder={wcode}
                    className="inputNone"
                    value={wcode}
                    onChange={(e) => setWcode(e.target.value)}
                />
            </div>
            <div className={`myBtn bg-prime w-100 text-center mb-5 mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={ValidateCode}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
            <p className="fw-bold mb-0 mt-5">Password</p>
            <p className="mb-2" style={{fontSize:'14px'}}>Edit user password.</p>
            <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>New password:</label>
            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                <input 
                    type={see?"text":"password"}
                    placeholder="Your new password (min. of 8 characters)"
                    className="inputNone"
                    value={pass}
                    onChange={(e) => setPass(e.target.value)}
                />
                <FontAwesomeIcon icon={(see === false)?faEye:faEyeSlash} className="ms-2" style={{fontSize: '12px'}} onClick={() => {
                    setSee(see === true ? false : true);
                }}/>
            </div>
            <div className={`myBtn bg-prime w-100 text-center mb-5 mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={ValidatePass}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
            <p className="fw-bold mb-0 mt-5">Delete account</p>
            <p className="mb-2" style={{fontSize:'14px'}}>Once you delete this account, there is no going back. Please be certain.</p>
            <div className={`myBtn bg-danger fw-bold text-white w-100 text-center mb-5 mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={ValidateDelete}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'DELETE ACCOUNT'}</div>
        </div>
    )
}

export default Security1